var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.6,
    strokeWidth: 1.3,
    d: "M8.555 12.45a1.4 1.4 0 0 0-1.006-1.006l-4.295-1.107a.35.35 0 0 1 0-.674L7.55 8.555A1.4 1.4 0 0 0 8.555 7.55l1.107-4.294a.35.35 0 0 1 .674 0l1.107 4.294a1.4 1.4 0 0 0 1.006 1.006l4.294 1.107a.35.35 0 0 1 0 .674l-4.294 1.107a1.4 1.4 0 0 0-1.006 1.006l-1.108 4.294a.35.35 0 0 1-.674 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M14.948 5.75v.75a.65.65 0 0 0 1.3 0v-.75h.75l.13-.013a.65.65 0 0 0 0-1.274l-.13-.013h-.75V3.7a.65.65 0 0 0-1.3 0v.75h-.75a.65.65 0 0 0 0 1.3zM3.749 14.85v.05a.65.65 0 0 0 1.3 0v-.05h.05l.131-.013a.65.65 0 0 0 0-1.274l-.13-.014h-.05v-.05a.65.65 0 0 0-1.301 0v.05h-.05a.65.65 0 0 0 0 1.301z",
    clipRule: "evenodd"
  })));
};
export default SvgSparkles;